import { genericFetchingActionCreator } from 'app/actions/genericActionCreator'
import { catchCommonErrors } from 'app/actions/commonActionUtils'

import { fetchAssignmentCorrespondence } from './fetchAssignmentCorrespondenceAction'

export const fetchAssignmentDetailByLin = (lin) => {
  return (dispatch, getState) => {
    const appraiserId = getState().currentUser.entities.find(e => e.name === 'AppraiserInspector').values.id
    dispatch(genericFetchingActionCreator('ASSIGNMENT_DETAILS', 'fetching'))
    fetch(`/lgyhub/api/appraiser-workspace/appraiser/${appraiserId}/property-appraisal/${lin}`, {
      credentials: 'include',
      method: 'get'
    }).then((response) => {
      return catchCommonErrors(dispatch, response, `locating case ${lin}`)
    }).then((responseJson) => {
      if (responseJson.status >= 400) {
        throw new Error(responseJson.errors[0].message)
      } else {
        dispatch(genericFetchingActionCreator('ASSIGNMENT_DETAILS', 'fetched', responseJson))
        dispatch(fetchAssignmentCorrespondence(responseJson.id, lin))
      }
    }).catch((error) => {
      dispatch(genericFetchingActionCreator('ASSIGNMENT_DETAILS', 'error'))
      console.error('Unable to fetch assignment details: ', error)
    })
  }
}
